module.exports = __webpack_public_path__ + "img/sale-amount-icon.88e4d2e7.png";